import React from "react";
import AdminServiceTickets from "../../components/dashboard/AdminServiceTickets";

const AdminPlatformJuridique = () => (
  <AdminServiceTickets
    serviceCode="juridique"
    title="Suivi juridique"
    lead="Les demandes juridiques des clients."
  />
);

export default AdminPlatformJuridique;
